/**
 * Format cents amount as a localized number string (no currency symbol).
 * Used across expense, settlement, and budget displays.
 *
 * @param cents - Amount in cents (will be divided by 100)
 * @returns Formatted number string (e.g., "12,500")
 */
export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat("ko-KR").format(cents / 100);
}

/**
 * Currency symbol mapping for supported currencies.
 */
const CURRENCY_SYMBOLS: Record<string, string> = {
  KRW: "\u20A9",
  JPY: "\u00A5",
  USD: "$",
  EUR: "\u20AC",
  GBP: "\u00A3",
  CNY: "\u00A5",
  THB: "\u0E3F",
  VND: "\u20AB",
};

/**
 * Format cents amount with a currency symbol prefix.
 * Falls back to the currency code itself if no symbol is mapped.
 *
 * @param cents - Amount in cents (will be divided by 100)
 * @param currency - ISO 4217 currency code (default: "KRW")
 * @returns Formatted string with symbol (e.g., "\u20A912,500")
 */
export function formatCurrencyWithUnit(
  cents: number,
  currency: string = "KRW",
): string {
  const symbol = CURRENCY_SYMBOLS[currency] ?? currency;
  return `${symbol}${new Intl.NumberFormat("ko-KR").format(cents / 100)}`;
}
